<template>
  <router-link :to="to" class="projects-button">
    {{ title }} <span class="projects-button__arrow"> ← </span>
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .projects-button {
    @include reset-link;
    @include text(big, bold);
    @include theme(color);

    &__arrow {
      display: inline-block;
      will-change: padding;
      transition: padding $base-transition;
    }

    &:hover &__arrow {
      padding-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Details/ProjectsButton.vue